/**
 * Console cleanup utility to suppress development noise
 * This should be imported early in the application lifecycle
 */

import { secureLogger } from './secureLogger';

// Apply console cleanup immediately when this module is imported
secureLogger.cleanConsole();

// Additional cleanup for production
if (process.env.NODE_ENV === 'production') {
  secureLogger.silence();
}

// Export for manual cleanup if needed
export const cleanConsole = () => {
  secureLogger.cleanConsole();
};

export const silenceConsole = () => {
  secureLogger.silence();
};